import React from 'react';
import { wantToOpenInNewTab } from '../../../utils/linkUtils';

type Props = {
  handleClick?: (openInNewTab: boolean) => void;
  clickable: boolean;
  color: string;
  label: string;
};

ChartLegendItem.defaultProps = {
  handleClick: () => {},
};

export function ChartLegendItem({
  handleClick,
  label,
  clickable,
  color,
}: Props) {
  return (
    <li
      onClick={event =>
        clickable && handleClick && handleClick(wantToOpenInNewTab(event))
      }
      key={label}
      className={clickable ? 'pointer' : ''}
    >
      <span
        className="chart-legend__color"
        style={{ backgroundColor: color }}
      />
      <span className="chart-legend__text">{label}</span>
    </li>
  );
}
